
import { isEqualShallow, clone } from "./conversion";

export interface FormatContext {
    bold?: boolean,
    italic?: boolean,
    underline?: boolean,

	id?: string,
	
	// field options
	field?: any,
}

export interface Segment {
    format: FormatContext,
    text: string,
}

export function cleanHtml(html: string) {
    var regex;
        
    regex = /(<([^>]+)>)/ig;
    var result = html.replace(regex, "");

    regex = /&nbsp;/ig;
    result = result.replace(regex, " ");

    return result;
}

export function simplifyHtmlIntoSegments(root: HTMLElement) {
    const segments: Segment[] = [];

	console.log("simplifyHtmlIntoSegments: " + root.outerHTML)

    const format = {
    };

    processChildren(segments, format, root);

    return segments;
}

function processChildren(segments: Segment[], format: FormatContext, el: HTMLElement) {
    for(var i=0;i<el.childNodes.length;i++) {
        const n = el.childNodes[i];

        // what is this node? is it text, or is it something that could imply formatting change?
        if (n.nodeType === 3) {
            // text

            // has the format changed since the last segment?
            // if not just append the text to it
            if (segments.length > 0) {
                const prevSeg = segments[segments.length-1];
                if (
                    //prevSeg.format.newPara || 
                    isEqualShallow(format, prevSeg.format)
                ) {
                    // same format so just tack text onto previous
                    prevSeg.text += n.textContent;
                    //prevSeg.format = clone(format);
                    continue;
                }
            }

            // else add a new segment
			const text = n.textContent ? n.textContent : "";
			// ignore stray tabs
			if (text.length > 0 && text.trim().length === 0 && segments.length > 0) {
				// ignore it
			} else {
				segments.push({
					format,
					text,
				});	
			}

        } else if (n.nodeType === 1) {
            // element

            // does it have any styles of relevance?
            const f = clone(format);
            const e = n as HTMLElement;

            const tagName = e.tagName.toLowerCase();
            if (tagName === "b") f.bold = true;
            if (tagName === "i") f.italic = true;
            if (tagName === "u") f.underline = true;

            const style = e.style; //window.getComputedStyle(e);
            if (style.fontWeight === "bold") f.bold = true;
            if (parseInt(style.fontWeight, 10) > 400) f.bold = true;
            if (style.fontStyle === "italic") f.italic = true;
            if (style.textDecoration === "underline") f.underline = true;

            const family = (style.fontFamily ? style.fontFamily : "").toLowerCase();
            if (family.indexOf(",bold") >= 0) f.bold = true;
            if (family.indexOf(",italic") >= 0) f.italic = true;

            if (tagName === "span" && e.className.toLowerCase() === "field-token") {
				f.id = e.getAttribute("id");
				f.field = JSON.parse(decodeURIComponent(e.getAttribute("data-options")!));
            }

            // if (tagName === "p") {
            //     //start of new paragraph
            //     segments.push({
            //         format: {
            //             newPara: true,
            //         },
            //         text: " ",
            //     });
            // }

			// // if a div element then start a new line
			// if (tagName === "div") {
			// 	segments.push({
			// 		format,
			// 		text: "\n",
			// 	});
			// }
            
            processChildren(segments, f, e);

            //if (f.newPara) f.newPara = false;

        } else {
            // ignore, e.g. comment node
        }

        //console.dir(el.childNodes[i]);
    }
}


export function htmlFromSegments(segments: Segment[]) {

    var parts = [];
    for(var i=0;i<segments.length;i++) {
        const seg = segments[i];

        const format = seg.format;

        if (format.bold) parts.push("<b>");
        if (format.italic) parts.push("<i>");
		if (format.underline) parts.push("<u>");

		if (format.field) {
            parts.push(
				'<span class="field-token" contentEditable="false" id="' + format.id + '"'
				+ " data-options='" + JSON.stringify(format.field) + "'>"); 


			// debugger;

			if (format.field && format.field.before) {
				parts.push(format.field.before)
			}
        }

        if (format.field && format.field.prop) {
			parts.push(format.field.prop);
		} else {
			parts.push(
				seg.text,
			);
		}

        // reverse order for closing tags
        if (format.field) {

			if (format.field.after) {
				parts.push(format.field.after)
			}

			parts.push('</span>');
        }

        if (format.underline) parts.push("</u>");
        if (format.italic) parts.push("</i>");
        if (format.bold) parts.push("</b>");

    }

    return parts.join("");
}

// from this source: https://stackoverflow.com/questions/6690752/insert-html-at-caret-in-a-contenteditable-div
// export function pasteHtmlAtCaret(html: string, selectPastedContent: boolean) {
//     var sel, range;

//     if (window.getSelection) {
//         // IE9 and non-IE
//         sel = window.getSelection();
//         if (sel && sel.getRangeAt && sel.rangeCount) {
//             range = sel.getRangeAt(0);
//             range.deleteContents();

//             // Range.createContextualFragment() would be useful here but is
//             // only relatively recently standardized and is not supported in
//             // some browsers (IE9, for one)
//             var el = document.createElement("div");
//             el.innerHTML = html;
//             var frag = document.createDocumentFragment(), node, lastNode;
//             while ( (node = el.firstChild) ) {
//                 lastNode = frag.appendChild(node);
//             }
//             var firstNode = frag.firstChild;
//             range.insertNode(frag);

//             // Preserve the selection
//             if (lastNode) {
//                 range = range.cloneRange();
//                 range.setStartAfter(lastNode);
//                 if (selectPastedContent) {
//                     range.setStartBefore(firstNode!);
//                 } else {
//                     range.collapse(true);
//                 }
//                 sel!.removeAllRanges();
//                 sel!.addRange(range);
//             }
//         }
//     } else if ( (sel = (document as any).selection) && sel.type !== "Control") {
//         // IE < 9
//         var originalRange = sel.createRange();
//         originalRange.collapse(true);
//         sel.createRange().pasteHTML(html);
//         if (selectPastedContent) {
//             range = sel.createRange();
//             range.setEndPoint("StartToStart", originalRange);
//             range.select();
//         }
//     }

//     if (document.activeElement) {
//         //simulateClick(document.activeElement);
//     }
// }

export function pasteHtmlAtCaret(html: string) {
	var sel, range;
	if (window.getSelection) {
		// Non-IE and modern IE (>=9)
		sel = window.getSelection() as any;
		if (sel.getRangeAt && sel.rangeCount) {
			range = sel.getRangeAt(0);
			range.deleteContents();

			// Create a temporary div to hold the HTML
			var el = document.createElement("div");
			el.innerHTML = html;
			var frag = document.createDocumentFragment(), node, lastNode;
			while ((node = el.firstChild)) {
				lastNode = frag.appendChild(node);
			}
			range.insertNode(frag);

			// Preserve the selection
			if (lastNode) {
				range = range.cloneRange();
				range.setStartAfter(lastNode);
				range.collapse(true);
				sel.removeAllRanges();
				sel.addRange(range);
			}
		}
	} else if ((document as any).selection && (document as any).selection.type != "Control") {
		// IE < 9
		(document as any).selection.createRange().pasteHTML(html);
	}
}

export function setCursorToEnd(element: HTMLElement) {
    element.focus();
	if (element.innerText) {
		const range = document.createRange();
		range.selectNodeContents(element);
		range.collapse(false);
		const sel = window.getSelection();
		if (sel) {
			sel.removeAllRanges();
			sel.addRange(range);	
		}	
	}
}